import { SaveButton } from "./components/SaveButton";
import { dispatchLivewireEvent } from "./Common/livewireCompat";

export default {
    init() {

        $('body').on('change', '#charge_or_refund input[name="charge_or_refund"]', function () {
            if ($('input[name="charge_or_refund"]:checked').val() == 'refund') {
                $('#order-transaction')
                    .removeAttr('disabled')
                    .attr('required', 'required');
                $('#charge_or_refund_label').text('Refund');
            } else {
                $('#order-transaction')
                    .removeAttr('required')
                    .attr('disabled', 'disabled');
                $('#charge_or_refund_label').text('Charge');
            }
        });

        $('body').on('input', '#user_search', function () {
            $.ajax({
                type: 'post',
                url: '/admin/adjustments_user_search',
                data: ({
                    search: $(this).val()
                }),
                success: function (response) {
                    $("#users_list").empty();
                    response.forEach((item) => {
                        var name = [item.first_name, item.last_name].filter(Boolean).join(' ');
                        var value = name + " (ID: " + item.id + ", Email: " + item.email + ")";
                        $("#users_list").append("<option data-id='" + item.id + "' value='" + value + "'></option>");
                    });
                },
                error: function (response) {

                },
            });
        });

        $('body').on('change', '#user_search', function (e) {
            var value = $("#user_search").val();
            var id = $('#users_list option').filter(function() {
                return this.value == value;
            }).data('id');
            
            $("#user_id").val(id);

            $.ajax({
                type: 'post',
                url: '/admin/adjustments_organisation_search',
                data: ({
                    user_id: $("#user_id").val()
                }),
                success: function (response) {
                    $("#organisations_list").empty();
                    response.forEach((item) => {
                        var value = item.name + "(ID: " + item.id + ", Address: " + item.address + ")";
                        $("#organisations_list").append("<option data-id='" + item.id + "' value='" + value + "'></option>");
                    });
                },
                error: function (response) {

                },
            });
        });

        $('body').on('change', '#organisation_search', function (e) {
            var value = $("#organisation_search").val();
            var id = $('#organisations_list option').filter(function() {
                return this.value == value;
            }).data('id');
            
            $("#adjustments-order-id").val(id);

            $.ajax({
                type: 'post',
                url: '/admin/adjustments_transactions_list',
                data: ({
                    order_id: id
                }),
                success: function (response) {
                    $('#order-transaction').empty();
                    $('#order-transaction').html(response);
                },
                error: function (response) {

                },
            });
        });

        $('body').on('submit', '#charge_or_refund', function () {
            $('#charge_or_refund_submit').attr('disabled', 'disabled');
        });

        this.confirmRefundModal();
        this.confirmRefund();
        this.cancelRefundModal();
        this.cancelRefund();
    },

    confirmRefundModal() {
        $('body').on('click', '.confirm_refund', function(e) {
            e.preventDefault();
            let reqId = $(e.currentTarget).attr('data-id')
            $('#accept-refund-btn').attr('data-id', reqId)
            $('#refund-confirmation-modal').modal('show');
        });
    },
    
    cancelRefundModal() {
        $('body').on('input', '#decline-refund-reason', function(e){
            if($(e.currentTarget).val()?.length)
                $('#decline-refund-btn').removeAttr('disabled')
            else
                $('#decline-refund-btn').attr('disabled', true)
        })
        $('body').on('click', '.cancel_refund', function(e) {
            e.preventDefault();
            let reqId = $(e.currentTarget).attr('data-id')
            $('#decline-refund-btn').attr('data-id', reqId)
            $('#refund-decline-modal').modal('show');
        });
    },

    confirmRefund() {
        let $this = this;
        $('body').on('click', '#accept-refund-btn', function(e) {
            e.preventDefault();
            const id = $(e.currentTarget).attr('data-id')
            const SaveBtn = new SaveButton(null, '#accept-refund-btn');
            $.ajax({
                type: 'POST',
                url: '/admin/confirm-refund',
                data: ({
                    req_id: id,
                }),
                beforeSend: () => {
                    SaveBtn.startLoading();
                },
                success: function (response) {
                    SaveBtn.stopLoading(response?.success ? true : false, 'Accept').then(() => {
                        if(response?.success){
                            SaveBtn.showSuccess().then(()=>setTimeout($('#refund-confirmation-modal').modal('hide'),1500))
                            dispatchLivewireEvent("refund_accepted")
                        }else
                            SaveBtn.showError().then()
                    })
                },
                error: function (response) {
                    SaveBtn.stopLoading(false, 'Accept').then(() => {
                        SaveBtn.showError().then()
                    });
                },
            });
        });
    },

    cancelRefund() {
        let $this = this;
        $('body').on('click', '#decline-refund-btn', function(e) {
            e.preventDefault();
            let id = $(e.currentTarget).attr('data-id')
            let reason = $('#decline-refund-reason').val();
            const SaveBtn = new SaveButton(null, '#decline-refund-btn');
            $.ajax({
                type: 'POST',
                url: '/admin/cancel-refund',
                data: ({
                    id: id,
                    reason: reason,
                }),
                beforeSend: () => {
                    SaveBtn.startLoading();
                },
                success: function (response) {
                    SaveBtn.stopLoading(response?.success ? true : false, 'Decline').then(() => {
                        if(response?.success){
                            SaveBtn.showSuccess().then(()=>setTimeout($('#refund-decline-modal').modal('hide'),1500))
                            $('#decline-refund-reason').val('')
                            dispatchLivewireEvent("refund_declined")
                        }
                        else
                            SaveBtn.showError().then()
                    })
                },
                error: function(response) {
                    SaveBtn.stopLoading(false, 'Decline').then(() => {
                        SaveBtn.showError().then()
                    });
                },
            });
        });
    },

    refundsList() {
        let params = new URLSearchParams(window.location.search);
        let page = params.get('page');
        $.ajax({
            type: 'GET',
            url: '/admin/refunds',
            data: ({
                list: true,
                page: page,
            }),
            success: function (response) {
                $('tbody').html(response);
            },
        });
    },
}
